import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token_emp' //token

const token_type = 'token_type_emp' //Bearer

const user_last_login = 'user_last_login_emp' //是否第一次登录

const userId = "userId_emp"

const TimeKey = "time_key" //首页加载时间

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

//Bearer
export function gettoken_type() {
    return Cookies.get(token_type)
}

export function settoken_type(type) {
    return Cookies.set(token_type, type)
}

export function removetoken_type() {
    return Cookies.remove(token_type)
}

export function setlast_login(type) {
    return Cookies.set(user_last_login, type)
}

export function getlast_login() {
    return Cookies.get(user_last_login)
}

export function setUserid(type) {
    return Cookies.set(userId, type)
}

export function getUserid() {
    return Cookies.get(userId)
}

// 时间
export function getTime() {
    return Cookies.get(TimeKey)
}

export function setTime(time) {
    return Cookies.set(TimeKey, time)
}

export function removeTime() {
    return Cookies.remove(TimeKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js